module.exports = __webpack_public_path__ + "static/media/xray-training-medial-flex3.2e590510.png";